import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  url: string;
  title?: string;
  onClose: () => void;
}

/** Modal náhled PDF (fotonávody). Iframe = nativní prohlížeč PDF; tlačítka stáhnout/otevřít jako fallback. */
const PdfModal: React.FC<Props> = ({ url, title = 'Fotonávod', onClose }) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  const content = (
    <div className="pdf-modal" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="pdf-modal__box" onClick={(e) => e.stopPropagation()}>
        <div className="pdf-modal__head">
          <span className="pdf-modal__title">{title}</span>
          <div className="pdf-modal__actions">
            <a className="pdf-modal__btn" href={url} target="_blank" rel="noopener noreferrer">Otevřít v novém okně</a>
            <a className="pdf-modal__btn" href={url} download>Stáhnout</a>
            <button className="pdf-modal__close" aria-label="Zavřít" onClick={onClose}>×</button>
          </div>
        </div>
        <div className="pdf-modal__body">
          <iframe className="pdf-modal__frame" src={url} title={title} />
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') return null;
  return createPortal(content, document.body);
};

export default PdfModal;
